import { Version } from 'app/shared/version/version';

export const PC_VERSION = new Version('17.2.0').full;
